<template>
  <div class="intro-y box mt-6">
    <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
      <h2 class="font-medium text-base mr-auto">
        Editar Email - <app-title-custom />
      </h2>
      <div class="form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0">
        Creada por:<label
          class="form-check-label ml-0 sm:ml-2"
          for="show-example-1"
          >{{ email_current.user_created_name }} -
          {{ email_current.created_at }}
        </label>
      </div>
    </div>
    <form @submit.prevent="updateElement" class="form-task">
      <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
        <div class="col-span-6 sm:col-span-6">
          <label>Nombre:</label>
          <input
            type="text"
            class="input w-full border mt-2 flex-1"
            v-model="email_current.name"
            required
            disabled
          />
        </div>
        <div class="col-span-6 sm:col-span-6">
          <label>Numero de pieza(s)</label>
          <select
            class="input w-full border mt-2 flex-1"
            v-model="email_current.number"
            required
            disabled
          >
            <option value="" disabled>Seleccione...</option>
            <option v-for="num in nums" :value="num">
              {{ num }}
            </option>
          </select>
        </div>
        <div class="col-span-4 sm:col-span-4">
          <label>Proyecto</label>
          <input
            type="text"
            class="input w-full border mt-2 flex-1"
            v-model="email_current.campaign_attribute.project_name"
            disabled
          />
        </div>
        <div class="col-span-4 sm:col-span-4">
          <label>Campaña</label>
          <input
            type="text"
            class="input w-full border mt-2 flex-1"
            v-model="email_current.campaign_attribute.name"
            disabled
          />
        </div>
        <div class="col-span-4 sm:col-span-4">
          <label>Fecha de entrega:</label>
          <input
            type="date"
            class="input w-full border mt-2 flex-1"
            v-model="email_current.date"
            required
          />
        </div>
        <div class="col-span-4 sm:col-span-4">
          <label>Urgente</label>
          <select
            class="input w-full border mt-2"
            v-model="email_current.urgent"
            required
          >
            <option disabled>Seleccione...</option>
            <option :value="false">NO</option>
            <option :value="true">SI</option>
          </select>
        </div>
        <div class="col-span-4 sm:col-span-4">
          <label>Estado</label>
          <select
            class="input w-full border mt-2"
            v-model="email_current.state_id"
            required
          >
            <option disabled>Seleccione el estado</option>
            <option v-for="state in states" :value="state.id">
              {{ state.name }}
            </option>
          </select>
        </div>
        <div class="col-span-4 sm:col-span-4" v-if="usersession.team_id == 1">
          <label>Realizado Por</label>
          <select
            class="input w-full border mt-2 flex-1"
            v-model="email_current.user_id"
            required
          >
            <option disabled>Seleccione el usuario</option>
            <option v-for="user in filteredUsers" v-bind:value="user.id">
              {{ user.name }}
            </option>
          </select>
        </div>
        <div class="col-span-4 sm:col-span-4" v-if="usersession.team_id == 1">
          <label>Revisado Por</label>
          <select
            class="input w-full border mt-2 flex-1"
            v-model="email_current.reviewed_by"
            required
          >
            <option disabled>Seleccione el usuario</option>
            <option v-for="user in filteredUsers" v-bind:value="user.id">
              {{ user.name }}
            </option>
          </select>
        </div>
        <div
          class="relative col-span-4 sm:col-span-4"
          v-if="email_current.path"
        >
          <label>Url Archivo</label>
          <input
            type="text"
            class="input w-full border mt-2 flex-1"
            v-model="email_current.path"
          />
          <a :href="email_current.path" target="_blank">
            <div
              class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
              v-if="email_current.path"
            >
              <app-icon name="link" classname="w-4 h-4" />
            </div>
          </a>
        </div>
        <!-- ANSWER -->
        <div
          class="col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
          v-if="
            [5, 7].includes(email_current.state_id) ||
            (email_current.state_id == 4 && usersession.team_id == 1)
          "
        >
          <div class="col-span-6 sm:col-span-6">
            <label>Descripcion Respuesta</label>
            <textarea
              class="input w-full border mt-2"
              rows="4"
              v-model="email_current.response_observations"
              required
            ></textarea>
          </div>
          <div class="relative col-span-6 sm:col-span-6">
            <div class="mb-2 relative">
              <label>Url Archivo Respuesta (Opcional)</label>
              <input
                type="text"
                class="input w-full border mt-2"
                v-model="email_current.response_path"
              />
              <a
                :href="email_current.response_path"
                target="_blank"
                v-if="email_current.response_path"
                class="courser-pointer"
              >
                <div
                  class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
                >
                  <app-icon name="link" classname="w-4 h-4" />
                </div>
              </a>
            </div>
          </div>
        </div>
        <!-- END ANSWER -->
      </div>
      <div class="px-5 py-3 text-right border-t border-gray-200">
        <button
          type="button"
          @click="$emit('closeEditEmail')"
          class="button border text-gray-700 mr-1"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="button bg-theme-1 text-white"
          id="edit"
          :disabled="buttonIsLoading"
        >
          <template v-if="buttonIsLoading"> Cargando... </template>
          <template v-else> Modificar </template>
        </button>
      </div>
    </form>

    <div v-if="email_current.versions">
      <div
        class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
      >
        <h2 class="font-medium text-base mr-auto">Versiones</h2>
      </div>
      <div
        class="grid grid-cols-12 items-center gap-5 p-5 border-b border-gray-200"
        v-for="version in email_current.versions"
      >
        <div class="col-span-6 mt-3 lg:mt-0">
          {{ version.observations }}
          <div class="text-gray-600 text-xs">{{ version.created_at }}</div>
          <a
            v-if="version.path"
            :href="version.path"
            class="button couser-pointer inline-block inline-flex bg-gray-200"
            target="_blank"
          >
            <app-icon name="link" classname="w-4 h-3 mt-1" /> &nbsp; Abrir Url
          </a>
        </div>
        <div
          class="col-span-6 mt-3 lg:mt-0"
          v-if="version.response_observations"
        >
          {{ version.response_observations }}
          <div class="text-gray-600 text-xs">{{ version.updated_at }}</div>
          <a
            v-if="version.response_path"
            :href="version.response_path"
            class="button couser-pointer inline-block inline-flex bg-gray-200"
            target="_blank"
          >
            <app-icon name="link" classname="w-4 h-3 mt-1" /> &nbsp; Abrir Url
          </a>
        </div>
        <div class="col-span-6 mt-3 lg:mt-0" v-else>
          <form class="intro-y gap-3" @submit.prevent="updateVersion(version)">
            <div class="col-span-6 sm:col-span-6 mb-1">
              <label>Descripcion</label>
              <textarea
                class="input w-full border mt-2"
                rows="3"
                v-model="version_current.response_observations"
                required
              ></textarea>
            </div>
            <div class="col-span-6 sm:col-span-6">
              <div class="mb-2">
                <label>Url Archivo (Opcional)</label>
                <input
                  type="text"
                  class="input w-full border mt-2"
                  v-model="version_current.response_path"
                />
              </div>
            </div>
            <div class="mt-3 col-span-12 sm:col-span-12">
              <button
                type="submit"
                id="editversion"
                class="button bg-theme-1 text-white"
                :disabled="buttonIsLoading"
              >
                <template v-if="buttonIsLoading"> Cargando... </template>
                <template v-else> Responder </template>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <form
      class="intro-y grid grid-cols-12 gap-3 p-5 form-task"
      @submit.prevent="createVersion"
    >
      <div class="col-span-6 sm:col-span-6">
        <label>Descripcion</label>
        <textarea
          class="input w-full border mt-2"
          rows="4"
          v-model="version.observations"
          required
        ></textarea>
      </div>
      <div class="col-span-6 sm:col-span-6">
        <div class="mb-2">
          <label>Url Archivo</label>
          <input
            type="text"
            class="input w-full border mt-2"
            v-model="version.path"
          />
        </div>
      </div>
      <div class="mt-8 col-span-12 sm:col-span-12">
        <button
          type="submit"
          id="createversion"
          class="button bg-theme-1 text-white"
          :disabled="buttonIsLoading"
        >
          <template v-if="buttonIsLoading"> Cargando... </template>
          <template v-else> Confirmar Nueva Version </template>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  props: ['nums', 'users', 'states', 'usersession', 'email_current'],
  data() {
    return {
      version: this.defineVersion(),
      version_current: this.defineResponseVersion(),
      createVersionVariable: false,
      options: [],
      buttonIsLoading: false,
    }
  },
  methods: {
    defineVersion() {
      return {
        entity: 'emailversion',
        path: '',
      }
    },
    defineResponseVersion() {
      return {
        entity: 'emailversion',
        response_observations: '',
        response_path: '',
      }
    },
    updateElement: function (value) {
      var vm = this
      vm.email_current.entity = 'email'
      this.buttonIsLoading = true
      console.log(vm.email_current)

      vm.update(vm.email_current)
        .then((item) => {
          this.$emit('emailEdited')
        })
        .finally(() => {
          this.$emit('emailEdited')
          this.buttonIsLoading = false
        })
    },
    createVersion() {
      var vm = this
      vm.version.email_id = this.email_current.id
      console.log(vm.version)
      this.buttonIsLoading = true
      vm.store(vm.version)
        .then((item) => {
          vm.version = this.defineVersion()
          window.location.reload()
        })
        .finally(() => {
          this.buttonIsLoading = false
        })
    },
    updateVersion(item) {
      var vm = this
      this.buttonIsLoading = true
      window.$('#editversion').button('loading')
      vm.version_current.id = item.id
      vm.store(vm.version_current)
        .then((item) => {
          vm.version = this.defineVersion()
          window.location.reload()
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
        })
        .finally(() => {
          this.buttonIsLoading = false
        })
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.version.path.push(newTag)
    },
    ...mapActions(['get', 'store', 'update']),
  },
  computed: {
    ...mapGetters({
      versions: 'getEmailVersion',
    }),
    filteredUsers() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(
          this.email_current.campaign_attribute.project_account_id
        )

        if (this.usersession.role == 4) {
          return search !== -1
        } else {
          return search !== -1 && item.team_id == localStorage.session_team
        }
      })
    },
  },
  components: {
    appIcon: Icon,
    appTitleCustom: TitleCustom,
    MultiSelect,
  },
}
</script>



// WEBPACK FOOTER //
// EmailEditModal.vue?84c48dda